import React from 'react';
import PropTypes from 'prop-types';
import { CROPZONE_ACTIVE_INGREDIENTS_TABLE } from '../../constants';

const ActiveIngredientCell = ({ ingredient, field }) => {
  const formatedValue = Number.isFinite(ingredient?.totalQuantity)
    ? ingredient.totalQuantity.toFixed(2)
    : 0;

  // One column of the row, picked by `field`: the UI Kit table renders
  // cell by cell.
  const cells = {
    name: ingredient.name,
    totalQuantity: `${formatedValue} 
          ${ingredient?.totalQuantityUnit ||
            CROPZONE_ACTIVE_INGREDIENTS_TABLE.defaultValueUnit}`
  };

  return cells[field] ?? null;
};

ActiveIngredientCell.propTypes = {
  field: PropTypes.string.isRequired,
  ingredient: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    totalQuantityUnit: PropTypes.string,
    totalQuantity: PropTypes.number
  }).isRequired
};

export default ActiveIngredientCell;
